
<form class="mce-form-section">

    <div class="mce-form-field-group">

        <div>
            <mat-form-field>
                <mat-label>{{ label() }}</mat-label>
                <mat-select [formField]="form().case">
                    @for (option of cases(); track option.value) {
                    <mat-option [value]="option.value">{{option.label}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>

        </div>

        @if(form().case().value() === spacingCase.EdgeToEdge) {

        <div>
            <mat-form-field>
                <mat-label>edge to edge, m</mat-label>
                <input matInput type="number" placeholder="edge to edge, m"
                       [formField]="form().edgeToEdge" />
                <span matSuffix>m</span>
                @for (error of form().edgeToEdge().errors(); track error.kind ) {
                <mat-error> {{ error.message }} </mat-error> }
            </mat-form-field>
        </div>

        }

    </div>

</form>
